import React, { useRef } from 'react';
import { Helmet } from 'react-helmet';
import ReactMarkdown from 'react-markdown';
import VideoScreen from 'common/components/VideoScreen';
import { ScalingPaddington } from 'common/components/Paddington';
import { H1 } from 'styles/text';
import { ScrollWrapper, PageWrapper, ImageContainer, TextContainer, PageContainer } from './styles';
import { useBackendStore } from 'services/backendService';
import Loader from 'components/Loader';
import { Link, useHistory } from 'react-router-dom';

export default function Home() {
  const env = useBackendStore(state => state.env);
  const history = useHistory();
  const wrapperRef = useRef();
  const home = useBackendStore(state => state.home);
  if (!home) return <Loader />;
  const { headerVideo, pageLinks } = home;
  const { video, thumbnail } = headerVideo;

  const clickHandler = path => {
    history.push(path);
  };

  return (
    <>
      <Helmet>
        <title>Nicetomeetyou macht Treffen zu Volltreffern.</title>
        <meta
          name="description"
          content="Vorträge – Coaching - Workshop - Beratung – Event. Wir geben guter Kommunikation Raum. Weil schlechte Treffen gutes Geld kosten."
        />
      </Helmet>
      <VideoScreen video={headerVideo && video.url} poster={thumbnail.url} />
      <ScalingPaddington>
        <ScrollWrapper>
          {pageLinks &&
            pageLinks.map((link, index) => (
              <PageWrapper ref={wrapperRef} key={index} isActive={true}>
                <PageContainer onClick={() => clickHandler(link.link)}>
                  <ImageContainer image={env + link.thumbnail.url}>
                    <img src={env + link.thumbnail.url} />
                  </ImageContainer>
                  <TextContainer>
                    <Link to={link.link + '/'}>
                      <H1>
                        <ReactMarkdown>{link.headline}</ReactMarkdown>
                      </H1>
                    </Link>
                  </TextContainer>
                </PageContainer>
              </PageWrapper>
            ))}
        </ScrollWrapper>
      </ScalingPaddington>
    </>
  );
}
